
export const ALL_GST_REQUEST = "ALL_GST_REQUEST";
export const ALL_GST_SUCCESS = "ALL_GST_SUCCESS";
export const ALL_GST_FAIL = "ALL_GST_FAIL";